(function () {
function $6b1037497eeac2d9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6b1037497eeac2d9$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6b1037497eeac2d9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6b1037497eeac2d9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $bb30d23c44a3a7f2$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $626eabffe98b4288$var$extendStatics = function extendStatics1(d, b) {
    $626eabffe98b4288$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $626eabffe98b4288$var$extendStatics(d, b);
};
function $626eabffe98b4288$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $626eabffe98b4288$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $626eabffe98b4288$export$18ce0697a983be9b = function __assign1() {
    $626eabffe98b4288$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $626eabffe98b4288$export$18ce0697a983be9b.apply(this, arguments);
};
function $626eabffe98b4288$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $626eabffe98b4288$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $626eabffe98b4288$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $626eabffe98b4288$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $626eabffe98b4288$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $626eabffe98b4288$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bb30d23c44a3a7f2$export$5f0017c582d45a2d)(x)) === "symbol" ? x : "".concat(x);
}
function $626eabffe98b4288$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bb30d23c44a3a7f2$export$5f0017c582d45a2d)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $626eabffe98b4288$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $626eabffe98b4288$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $626eabffe98b4288$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $626eabffe98b4288$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $626eabffe98b4288$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $626eabffe98b4288$export$45d3717a4c69092e(o, m, p);
}
function $626eabffe98b4288$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $626eabffe98b4288$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $626eabffe98b4288$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($626eabffe98b4288$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $626eabffe98b4288$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $626eabffe98b4288$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $626eabffe98b4288$export$10c90e4f7922046c(v) {
    return this instanceof $626eabffe98b4288$export$10c90e4f7922046c ? (this.v = v, this) : new $626eabffe98b4288$export$10c90e4f7922046c(v);
}
function $626eabffe98b4288$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $626eabffe98b4288$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $626eabffe98b4288$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $626eabffe98b4288$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $626eabffe98b4288$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $626eabffe98b4288$export$19a8beecd37a4c45 === "function" ? $626eabffe98b4288$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $626eabffe98b4288$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $626eabffe98b4288$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $626eabffe98b4288$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $626eabffe98b4288$export$45d3717a4c69092e(result, mod, k);
    }
    $626eabffe98b4288$var$__setModuleDefault(result, mod);
    return result;
}
function $626eabffe98b4288$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $626eabffe98b4288$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $626eabffe98b4288$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $626eabffe98b4288$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $626eabffe98b4288$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $626eabffe98b4288$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $626eabffe98b4288$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $626eabffe98b4288$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $626eabffe98b4288$export$2e2bcd8739ae039 = {
    __extends: $626eabffe98b4288$export$a8ba968b8961cb8a,
    __assign: $626eabffe98b4288$export$18ce0697a983be9b,
    __rest: $626eabffe98b4288$export$3c9a16f847548506,
    __decorate: $626eabffe98b4288$export$29e00dfd3077644b,
    __param: $626eabffe98b4288$export$d5ad3fd78186038f,
    __metadata: $626eabffe98b4288$export$f1db080c865becb9,
    __awaiter: $626eabffe98b4288$export$1050f835b63b671e,
    __generator: $626eabffe98b4288$export$67ebef60e6f28a6,
    __createBinding: $626eabffe98b4288$export$45d3717a4c69092e,
    __exportStar: $626eabffe98b4288$export$f33643c0debef087,
    __values: $626eabffe98b4288$export$19a8beecd37a4c45,
    __read: $626eabffe98b4288$export$8d051b38c9118094,
    __spread: $626eabffe98b4288$export$afc72e2116322959,
    __spreadArrays: $626eabffe98b4288$export$6388937ca91ccae8,
    __spreadArray: $626eabffe98b4288$export$1216008129fb82ed,
    __await: $626eabffe98b4288$export$10c90e4f7922046c,
    __asyncGenerator: $626eabffe98b4288$export$e427f37a30a4de9b,
    __asyncDelegator: $626eabffe98b4288$export$bbd80228419bb833,
    __asyncValues: $626eabffe98b4288$export$e3b29a3d6162315f,
    __makeTemplateObject: $626eabffe98b4288$export$4fb47efe1390b86f,
    __importStar: $626eabffe98b4288$export$c21735bcef00d192,
    __importDefault: $626eabffe98b4288$export$da59b14a69baef04,
    __classPrivateFieldGet: $626eabffe98b4288$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $626eabffe98b4288$export$d40a35129aaff81f,
    __classPrivateFieldIn: $626eabffe98b4288$export$81fdc39f203e4e04,
    __addDisposableResource: $626eabffe98b4288$export$88ac25d8e944e405,
    __disposeResources: $626eabffe98b4288$export$8f076105dc360e92
};



function $2a6662d9c8fe76ee$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $04ddefc5f497130f$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $ed1f432d94cf8310$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $cfaea77c29398b74$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $e440fca4b737b82f$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $cfaea77c29398b74$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $cfaea77c29398b74$export$79e617b1955a2616)(o, minLen);
}


function $6bdb1ac2f8376318$export$fdf2a89c76341bbf(arr, i) {
    return (0, $2a6662d9c8fe76ee$export$e6256bf45c68d561)(arr) || (0, $04ddefc5f497130f$export$2fd15edff6687200)(arr, i) || (0, $e440fca4b737b82f$export$a5be06335b3a083c)(arr, i) || (0, $ed1f432d94cf8310$export$60dbc22abd7da546)();
}



function $affdfa6bbf1c61d1$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $cfaea77c29398b74$export$79e617b1955a2616)(arr);
}


function $32a24af851309dfe$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $48ed7de51248fbfd$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $2c5e0c4ca64c569e$export$1b5e630bc3aea29f(arr) {
    return (0, $affdfa6bbf1c61d1$export$7e0947b5ad3404e2)(arr) || (0, $32a24af851309dfe$export$1eb58a6e75231000)(arr) || (0, $e440fca4b737b82f$export$a5be06335b3a083c)(arr) || (0, $48ed7de51248fbfd$export$e6f3c4780d19eb2b)();
}





//********************** */
//* Global variables
//********************** */
// loading spinner Element
var $35395ebfc9972efa$var$loadingElement = document.body.querySelector(".loading-container");
//*********************************************** */
//* Game board cells and keyboard Functions
//*********************************************** */
//********************* */
//* Main Functions
//********************* */
/*
  * cell animation function takes four arguments:
    ** rowCells => which is one cell or all cells (one cell for removing, all cells for adding or validating)
    ** keyValue => the value of the pressed key either on user keyboard or virtual one
    ** validationArray, keyboardButtons => only used in the enter key to 
    ** animate when validating in both game board cells and keyboard buttons
*/ function $35395ebfc9972efa$export$2b30b4c5c46f02b8(rowCells, keyValue, validationArray, keyboardButtons) {
    // unify input
    keyValue = keyValue.toLowerCase();
    if (keyValue === "enter") {
        if (validationArray === undefined) $35395ebfc9972efa$var$rejectionAnimation(rowCells);
        else $35395ebfc9972efa$var$validationAnimation(rowCells, validationArray, keyboardButtons);
    } else if (keyValue === "backspace") {
        // rowCells is only 1 cell in this block, so it's more logical that the variable represents it's meaning
        var rowCell = rowCells;
        $35395ebfc9972efa$var$animateAndRemove(rowCell);
    } else $35395ebfc9972efa$var$addingAnimation(rowCells);
}
//********************* */
//* Helper Functions
//********************* */
/*
  * This function handles the animation of wrong input for the Enter key
    ** RowCells => the cells that the animation is applied to
*/ function $35395ebfc9972efa$var$rejectionAnimation(rowCells) {
    // Get Cells Parent => (row)
    var row = rowCells[0].parentNode;
    // add row animation
    row.classList.add("row-rejection");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add cells animation
        for(var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            cell.classList.add("cell-rejection");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // remove the row and cells animations after duration ends
    setTimeout(function() {
        row.classList.remove("row-rejection");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cell = _step.value;
                cell.classList.remove("cell-rejection");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, 1000);
}
/*
  * This function handles the animation of valid input for the Enter key
    ** RowCells => the cells that the animation is applied to
    ** validationArray => the array that determines how each cell will be changed (true => correct, "close" => close, false => missing)
    ** keyboardButtons => all keyboard buttons (to apply animation to corresponding buttons)
*/ function $35395ebfc9972efa$var$validationAnimation(rowCells, validationArray, keyboardButtons) {
    var _loop = function(i) {
        // current cell in row
        var currentCell = rowCells[i];
        // find relative keyboard button in the on-screen keyboard
        var keyboardButton = void 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keyboardButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var button = _step.value;
                // toUpperCase is mostly unnecessary here but just for strict checking
                if (button.innerText.toUpperCase() === currentCell.innerText.toUpperCase()) keyboardButton = button;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // current validation cell value
        var validationCell = validationArray[i];
        // get the current theme
        var currentTheme = document.querySelector(".switch__checkbox").getAttribute("data-theme");
        // animate current row cell and keyboard button
        currentCell.classList.add("game-board-validation");
        keyboardButton.classList.add("keyboard-validation");
        // give different delay between each cell and each keyboard button
        currentCell.style.animationDelay = "".concat(i * animationDelay, "s");
        keyboardButton.style.animationDelay = "".concat(i * animationDelay, "s");
        // after half of the animation time passes, add the validation relative colors
        setTimeout(function() {
            // change cells and keyboard colors for visual feedback
            $35395ebfc9972efa$var$handleValidationColors(currentCell, keyboardButton, validationCell, currentTheme);
        }, 500 + i * (animationDelay * 1000));
        // remove keyboard animation after finishing
        setTimeout(function() {
            keyboardButton.classList.remove("keyboard-validation");
            keyboardButton.style.removeProperty("animation-delay");
        }, 1000 + i * (animationDelay * 1000));
    };
    // animation delay for each cell
    var animationDelay = 0.15;
    // for each value in validationArray
    for(var i = 0; i < validationArray.length; i++)_loop(i);
}
/*
  * This function adds the relative coloring class to current cell and current keyboard button
    ** based on the values of validationCell and currentTheme
*/ function $35395ebfc9972efa$var$handleValidationColors(currentCell, currentKeyboardButton, validationCell, currentTheme) {
    // general cell and keyboard button classes
    var cellClass = "game-board__letter";
    var btnClass = "keyboard__letter";
    if (validationCell === true) {
        // correct state classes
        var correctCellClass = "".concat(cellClass, "--correct");
        var correctBtnClass = "".concat(btnClass, "--correct");
        // add default classes
        currentCell.classList.add(correctCellClass);
        currentKeyboardButton.classList.add(correctBtnClass);
        // check for dark theme and apply related classes if found
        if (currentTheme === "dark") {
            currentCell.classList.add("".concat(correctCellClass, "-dark"));
            currentKeyboardButton.classList.add("".concat(correctBtnClass, "-dark"));
        }
    } else if (validationCell === "close") {
        // close state classes
        var closeCellClass = "".concat(cellClass, "--close");
        var closeBtnClass = "".concat(btnClass, "--close");
        currentCell.classList.add(closeCellClass);
        currentKeyboardButton.classList.add(closeBtnClass);
        if (currentTheme === "dark") {
            currentCell.classList.add("".concat(closeCellClass, "-dark"));
            currentKeyboardButton.classList.add("".concat(closeBtnClass, "-dark"));
        }
    } else {
        // missing state classes
        var missingCellClass = "".concat(cellClass, "--missing");
        var missingBtnClass = "".concat(btnClass, "--missing");
        currentCell.classList.add(missingCellClass);
        currentKeyboardButton.classList.add(missingBtnClass);
        if (currentTheme === "dark") {
            currentCell.classList.add("".concat(missingCellClass, "-dark"));
            currentKeyboardButton.classList.add("".concat(missingBtnClass, "-dark"));
        }
    }
}
/*
  * This function takes as argument one cell, adds removal animation and removes it's content
    ** Just as specified in animateAndRemoveLetter function (input.mjs)
    ** this function handles both the input functionality and animation functionality
*/ function $35395ebfc9972efa$var$animateAndRemove(rowCell) {
    // choose the cell span element
    var cellText = rowCell.querySelector(".letter-text");
    // add removing animation to span
    cellText.classList.add("letter-removing");
    // after animation ends
    setTimeout(function() {
        // remove cell content
        cellText.innerText = "";
        // remove animation to allow for future animations
        cellText.classList.remove("letter-removing");
    }, 200);
}
//* Function to add the insertion animation on the last occupied cell
function $35395ebfc9972efa$var$addingAnimation(rowCells) {
    // find last occupied cell
    var lastOccupiedCell;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            if (cell.innerText !== "") lastOccupiedCell = cell;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // choose cell span Element
    var cellText = lastOccupiedCell.querySelector(".letter-text");
    // add animations to the cell
    cellText.classList.add("letter-adding");
    // remove animations from the cell after animation ends
    setTimeout(function() {
        return cellText.classList.remove("letter-adding");
    }, 200);
}
//* Function to mimic validation animation for how to play dialog fake game row
function $35395ebfc9972efa$export$8be79abfbbb1b7ab(rowCells) {
    var _loop = function(i) {
        // get current cell
        var currentCell = rowCells[i];
        // animate fake cell
        setTimeout(function() {
            currentCell.classList.add("game-board-validation");
        }, 200 + i * animationDelay);
        // remove cell animation after finishing
        setTimeout(function() {
            currentCell.classList.remove("game-board-validation");
        }, 1200 + i * animationDelay);
    };
    var animationDelay = 150;
    for(var i = 0; i < rowCells.length; i++)_loop(i);
}
/*
  * Function to handle keyboard animations on different keydown events
    ** backspace event
    ** enter
    ** other uppercase-lowercase letters
*/ function $35395ebfc9972efa$export$5c4515537cbee0e0(keyboardButtons, keyValue) {
    // set initial variables
    var pressedButton;
    var keyLowerCased = keyValue.toLowerCase();
    // Get corresponding pressed button on keyboard
    if (keyLowerCased === "backspace") {
        //* if removing a letter
        // get backspace button
        pressedButton = document.querySelector(".backspace-button");
        // Add animation
        pressedButton.classList.add("backspace-typing");
    } else if (keyLowerCased === "enter") {
        //* if submitting a guess
        // get enter button
        pressedButton = document.querySelector(".enter-button");
        // Add animation
        pressedButton.classList.add("enter-typing");
    } else {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            //* for other buttons
            // find relative button on keyboard
            for(var _iterator = keyboardButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var button = _step.value;
                //* button text lowercasing is unnecessary for most cases only for stricter checking
                if (button.innerHTML.toLowerCase() === keyLowerCased) {
                    pressedButton = button;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Add animation
        pressedButton.classList.add("letter-typing");
    }
    // for other keys (symbols, numbers...etc)
    if (pressedButton === undefined) {
        $35395ebfc9972efa$var$fun();
        return;
    }
}
/*
  * Function to remove keyboard animations on keyup event
    ** the animation on each button is added once with keyboardAnimation function
    ** and removed only with key is released
*/ function $35395ebfc9972efa$export$82f1d4313688e804(keyboardButtons, keyValue) {
    // Get pressed button and unify input
    var pressedButton;
    var keyLowerCased = keyValue.toLowerCase();
    // check cases
    if (keyLowerCased === "backspace") pressedButton = document.querySelector(".backspace-button");
    else if (keyLowerCased === "enter") pressedButton = document.querySelector(".enter-button");
    else {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keyboardButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var button = _step.value;
                if (button.innerHTML.toLowerCase() === keyLowerCased) {
                    pressedButton = button;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // if other buttons are pressed
    if (pressedButton === undefined) {
        $35395ebfc9972efa$var$fun();
        return;
    }
    // remove after animation duration is complete
    setTimeout(function() {
        if (pressedButton.classList.contains("backspace-typing")) pressedButton.classList.remove("backspace-typing");
        else if (pressedButton.classList.contains("enter-typing")) pressedButton.classList.remove("enter-typing");
        else if (pressedButton.classList.contains("letter-typing")) pressedButton.classList.remove("letter-typing");
    }, 150);
}
var $35395ebfc9972efa$var$fun = function() {
    console.log("Know what the button said to the clicker? \n~crying in sadness~ \nit just feels like, you're always pushing me away \uD83D\uDE22");
};
//************************************** */
//* Dialogs Functions
//************************************** */
//* Function that adds the entry animation to a dialog
function $35395ebfc9972efa$export$21d6af064bc42dba(dialog) {
    dialog.classList.add("dialog-entry");
}
//* Function that adds the exit animation to a dialog and removes hanging animations classes
function $35395ebfc9972efa$export$48363b365af47301(dialog) {
    dialog.classList.remove("dialog-entry");
    dialog.classList.add("dialog-exit");
    setTimeout(function() {
        dialog.classList.remove("dialog-exit");
    }, 500);
}
//************************************** */
//* loading element Functions
//************************************** */
//* Function to show loading spinner element
function $35395ebfc9972efa$export$64858b67578a10bb() {
    $35395ebfc9972efa$var$loadingElement.style.visibility = "visible";
}
//* Function to hide loading spinner element
function $35395ebfc9972efa$export$7d026bf51c574e0d() {
    $35395ebfc9972efa$var$loadingElement.style.visibility = "hidden";
}


//********************* */
//* Main Functions
//********************* */
/*
  * all input functions returns true only if any change has been made
    ** eg. added a letter, removed a letter or pressed enter (has no effect, just for consistency sake)
*/ function $5a4e68405bab07b3$export$412508d679148d5c(rowCells, key) {
    // unify input
    key = key.toLowerCase();
    // check cases
    if (key === "backspace") return $5a4e68405bab07b3$var$animateAndRemoveLetter(rowCells);
    else if (key === "enter") return true;
    else if ($5a4e68405bab07b3$var$isLetter(key)) return $5a4e68405bab07b3$var$addLetter(rowCells, key); // add a letter
}
//********************* */
//* Helper Functions
//********************* */
/*
  * Function that animates the last occupied cell and then removes it's content
    ** this is the only function that applies a side effect in input functions
    ** due to the fact that the animation needs to be applied before removing the letter
*/ function $5a4e68405bab07b3$var$animateAndRemoveLetter(rowCells) {
    // iterate backwards on row
    for(var i = rowCells.length - 1; i >= 0; i--)// find last occupied cell
    if (rowCells[i].innerText !== "") {
        // Add animation and remove cell content
        (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells[i], "backspace");
        break;
    }
    return true;
}
//* Function that adds a letter to the next empty cell in the current row
function $5a4e68405bab07b3$var$addLetter(rowCells, keyValue) {
    // initial value for last empty cell
    var lastEmptyCell;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // find last empty cell
        for(var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            if (cell.innerText === "") {
                // set last empty cell and break
                lastEmptyCell = cell;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // if all cells are occupied
    if (lastEmptyCell === undefined) return false;
    // get cell span element
    var emptyCellText = lastEmptyCell.childNodes[0];
    // add content to span
    emptyCellText.innerText = keyValue.toUpperCase();
    return true;
}
//* Function to check if a character is an uppercase or lowercase letter
var $5a4e68405bab07b3$var$isLetter = function(letter) {
    var regex = /^[a-zA-Z]$/;
    return regex.test(letter);
};










//********************* */
//* Global Variables
//********************* */
// track user progress
var $d5d5633d8628c6dd$export$7abfd4649f15e11f = {
    currentRow: 0,
    isSolved: false
};
var $d5d5633d8628c6dd$export$af20da7343c4b20b = JSON.parse($d5d5633d8628c6dd$export$ed608b63f17f3f82());
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Function that retrieves previous user progress or creates new one
    ** if first session or a new day => initiate a new userProgress object
    ** otherwise => get previous user progress object
*/ function $d5d5633d8628c6dd$export$ed608b63f17f3f82() {
    if (localStorage.getItem("userProgress") === null || (0, $b7ce30cf16a265d9$export$c3e675fb255e6adf)()) return $d5d5633d8628c6dd$var$initUserProgress();
    else return localStorage.getItem("userProgress");
}
/*
  * This function saves the current user progress in the local storage
    ** Saves current row number
    ** Saves added cells text and classes
    ** Saves added keyboard buttons classes
    ** tracks if the game has been solved or not
*/ function $d5d5633d8628c6dd$export$384cd953322e3851(rowCells) {
    // save last finished row number
    $d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow = $d5d5633d8628c6dd$export$7abfd4649f15e11f.currentRow;
    // save cells data
    $d5d5633d8628c6dd$var$saveCellsState(rowCells);
    // save keyboard data
    $d5d5633d8628c6dd$var$saveKeyboardState();
    // save if the user solved the puzzle
    if ($d5d5633d8628c6dd$export$7abfd4649f15e11f.isSolved) $d5d5633d8628c6dd$export$af20da7343c4b20b.isSolved = true;
    // push the new game state back to the local storage
    localStorage.setItem("userProgress", JSON.stringify($d5d5633d8628c6dd$export$af20da7343c4b20b));
}
function $d5d5633d8628c6dd$export$70a369479cdf5432(previousGameState) {
    return $d5d5633d8628c6dd$var$_applyPreviousGameState.apply(this, arguments);
}
function $d5d5633d8628c6dd$var$_applyPreviousGameState() {
    $d5d5633d8628c6dd$var$_applyPreviousGameState = //* This function applies last user session game state
    (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function(previousGameState) {
        var todayWord, positions;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // set user current row
                    $d5d5633d8628c6dd$export$7abfd4649f15e11f.currentRow = previousGameState.currentRow + 1;
                    // set if the user solved the game or not
                    $d5d5633d8628c6dd$export$7abfd4649f15e11f.isSolved = previousGameState.isSolved;
                    // set cells to previous state (text - classes)
                    $d5d5633d8628c6dd$var$setPreviousCellsState();
                    // set keyboard button to previous state (classes)
                    $d5d5633d8628c6dd$var$setPreviousKeyboardState();
                    if (!(previousGameState.currentRow === 5 && !previousGameState.isSolved)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $b7ce30cf16a265d9$export$a5bfddfac516cc04)()
                    ];
                case 1:
                    todayWord = _state.sent();
                    (0, $8652910d8928cb3c$export$6ec214f034b61612)("Correct word: ".concat(todayWord.toUpperCase()), true);
                    return [
                        3,
                        3
                    ];
                case 2:
                    if (previousGameState.isSolved) {
                        positions = [
                            "first",
                            "second",
                            "third",
                            "fourth",
                            "fifth",
                            "sixth"
                        ];
                        (0, $8652910d8928cb3c$export$6ec214f034b61612)("Excellent work!, You solved today's word in the ".concat(positions[previousGameState.currentRow], " row"), true);
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $d5d5633d8628c6dd$var$_applyPreviousGameState.apply(this, arguments);
}
/*
  * This function removes last user session game state
*/ function $d5d5633d8628c6dd$export$2dc65a8d5a607c9a() {
    localStorage.removeItem("userProgress");
}
//****************************************************** */
//* Helper Functions
//****************************************************** */
//* this function initiates a user progress Object in the local storage and returns it
function $d5d5633d8628c6dd$var$initUserProgress() {
    // initialize initial variables
    var totalRows = 6;
    var totalRowCells = 5;
    var totalKeyboardBtns = 26;
    var rowsData = [], rowsClasses = [], keyboardBtnsClasses = [];
    // for each row
    for(var i = 0; i < totalRows; i++){
        // set initial cells text data
        rowsData[i] = Array(totalRowCells).fill("");
        // set initial cells applied classes
        rowsClasses[i] = Array(totalRowCells).fill("");
    }
    // for each keyboard button
    var allButtons = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // set buttons classes initial values
    for(var i1 = 0; i1 < totalKeyboardBtns; i1++)keyboardBtnsClasses[i1] = [
        allButtons[i1].innerText,
        ""
    ];
    /*
    * currentRow => the guess row the user is currently at
    * rowsData => the text data for each cell, with a total of five cells for each row
    * rowsClasses => the applied class for each cell on each row
    * keyboardClasses => the applied class for each keyboard button
    * isSolved => boolean indicating whether the word is solved or not
  */ localStorage.setItem("userProgress", JSON.stringify({
        currentRow: -1,
        rowsData: rowsData,
        rowsClasses: rowsClasses,
        keyboardClasses: keyboardBtnsClasses,
        isSolved: false
    }));
    return localStorage.getItem("userProgress");
}
//* Helper function to set previous cells state (text - classes)
function $d5d5633d8628c6dd$var$setPreviousCellsState() {
    // set completed rows data and classes to previous game state
    // get all rows
    var allRows = document.querySelectorAll(".game-board__row");
    for(var i = 0; i <= $d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow; i++){
        // get current completed row and his children (cells)
        var currentRow = allRows[i];
        var rowChildren = currentRow.children;
        // mark as done
        currentRow.setAttribute("data-state", "DONE");
        // for each cell 
        for(var j = 0; j < rowChildren.length; j++){
            // get current cell and it's span
            var currentCell = rowChildren[j];
            var currentCellSpan = currentCell.childNodes[0];
            // add cell text from previous session to current cell
            currentCellSpan.innerText = $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsData[i][j];
            // get the cell class used in the previous session
            var correspondingCellClass = $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsClasses[i][j];
            // apply the validation animation to cell
            currentCell.classList.add("game-board-validation");
            // add animation duration
            currentCell.style.animationDelay = "".concat(i * 0.03, "s");
            // add the color class to the cell
            currentCell.classList.add(correspondingCellClass);
        }
    }
}
//* Helper function to set previous keyboard state (classes)
function $d5d5633d8628c6dd$var$setPreviousKeyboardState() {
    var _loop = function(i) {
        var currentBtn = allButtons[i];
        // get corresponding previous class for the current button
        var btnPreviousClass = $d5d5633d8628c6dd$export$af20da7343c4b20b.keyboardClasses[i][1];
        // if button has been chosen in previous session
        if (btnPreviousClass !== "") {
            // apply the validation animation to cell
            currentBtn.classList.add("keyboard-validation");
            // add animation duration
            currentBtn.style.animationDelay = "".concat(i * 0.03, "s");
            // add the color class to the cell
            currentBtn.classList.add(btnPreviousClass);
            // remove animation and delay for future animations
            setTimeout(function() {
                currentBtn.classList.remove("keyboard-validation");
                currentBtn.style.removeProperty("animation-delay");
            }, 1000 + i * 30);
        }
    };
    // Get all buttons (without enter and backspace buttons)
    var allButtons = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // iterate over each button
    for(var i = 0; i < allButtons.length; i++)_loop(i);
}
//* Function to save current Cells text and classes after each validation 
function $d5d5633d8628c6dd$var$saveCellsState(rowCells) {
    //* save cells text and classes data
    var totalRowCells = 5;
    // for each row cell
    for(var i = 0; i < totalRowCells; i++){
        // for each cell in the current row add the corresponding cell text
        $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsData[$d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow][i] = rowCells[i].childNodes[0].innerText;
        // save the corresponding cells Classes
        var cellClasses = rowCells[i].classList;
        var cellClassGenre = "game-board__letter--";
        if (cellClasses.contains("".concat(cellClassGenre, "correct"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsClasses[$d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow][i] = "".concat(cellClassGenre, "correct");
        else if (cellClasses.contains("".concat(cellClassGenre, "close"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsClasses[$d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow][i] = "".concat(cellClassGenre, "close");
        else if (cellClasses.contains("".concat(cellClassGenre, "missing"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.rowsClasses[$d5d5633d8628c6dd$export$af20da7343c4b20b.currentRow][i] = "".concat(cellClassGenre, "missing");
    }
}
//* Function that saves keyboard buttons added classes after each validation
function $d5d5633d8628c6dd$var$saveKeyboardState() {
    // total keyboard buttons (without enter and backspace)
    var totalKeyboardBtns = 26;
    var keyboardBtns = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // save the corresponding keyboard buttons classes
    var keyboardClassGenre = "keyboard__letter--";
    // add the keyboard buttons classes
    for(var i = 0; i < totalKeyboardBtns; i++){
        var currentBtnClasses = keyboardBtns[i].classList;
        if (currentBtnClasses.contains("".concat(keyboardClassGenre, "correct"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.keyboardClasses[i][1] = "".concat(keyboardClassGenre, "correct");
        else if (currentBtnClasses.contains("".concat(keyboardClassGenre, "close"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.keyboardClasses[i][1] = "".concat(keyboardClassGenre, "close");
        else if (currentBtnClasses.contains("".concat(keyboardClassGenre, "missing"))) $d5d5633d8628c6dd$export$af20da7343c4b20b.keyboardClasses[i][1] = "".concat(keyboardClassGenre, "missing");
    }
}


//********************* */
//* Global Variables
//********************* */
//* settings and howToPlay dialogs
var $c760ed1227d077e8$var$settingsDialog = document.querySelector(".settings-dialog");
var $c760ed1227d077e8$var$howToPlayDialog = document.querySelector(".how-to-play-dialog");
//* dark mode switch and checkbox and user OS color scheme preference
var $c760ed1227d077e8$var$darkModeSwitch = document.querySelector(".theme-switch");
var $c760ed1227d077e8$var$checkbox = $c760ed1227d077e8$var$darkModeSwitch.querySelector(".switch__checkbox");
//* all the single elements classes needed to apply dark mode
var $c760ed1227d077e8$var$singleElementsClasses = [
    "feedback-message",
    "header__title",
    "keyboard",
    "theme-switch"
];
//* all the multiple elements classes needed to apply dark mode
// elements that needs one hyphen (-dark) to apply dark mode 
var $c760ed1227d077e8$var$singleHyphenElements = [
    "game-board__letter--missing",
    "game-board__letter--close",
    "game-board__letter--correct",
    "keyboard__letter--missing",
    "keyboard__letter--close",
    "keyboard__letter--correct",
    "fake-letter--missing",
    "fake-letter--close",
    "fake-letter--correct"
];
// elements that needs two hyphen (--dark) to apply dark mode 
var $c760ed1227d077e8$var$doubleHyphenElements = [
    "game-board__letter",
    "keyboard__letter",
    "row-separator",
    "fake-letter",
    "subheader-text",
    "how-to-play__headings",
    "how-to-play__list",
    "loading-container",
    "loading-spinner",
    "source-notice"
];
var $c760ed1227d077e8$var$multipleElementsClasses = [
    $c760ed1227d077e8$var$singleHyphenElements,
    $c760ed1227d077e8$var$doubleHyphenElements
];
// light and dark theme SVG elements
var $c760ed1227d077e8$var$lightThemeSVGs = document.body.querySelectorAll(".light-theme__svg");
var $c760ed1227d077e8$var$darkThemeSVGs = document.body.querySelectorAll(".dark-theme__svg");
//**********************************
//* General dialog Functions
//**********************************/
function $c760ed1227d077e8$var$openDialog(dialogName) {
    if (dialogName === "settings") {
        // add dialog entry animation
        (0, $35395ebfc9972efa$export$21d6af064bc42dba)($c760ed1227d077e8$var$settingsDialog);
        // show dialog and give focus to it
        $c760ed1227d077e8$var$settingsDialog.showModal();
        $c760ed1227d077e8$var$settingsDialog.focus();
    } else if (dialogName === "howToPlay") {
        (0, $35395ebfc9972efa$export$21d6af064bc42dba)($c760ed1227d077e8$var$howToPlayDialog);
        $c760ed1227d077e8$var$howToPlayDialog.showModal();
        $c760ed1227d077e8$var$howToPlayDialog.focus();
    }
    // add an event listener on page for the ESC key and outside the modal box clicks
    document.addEventListener("keydown", $c760ed1227d077e8$var$handleEscKeyClick(dialogName));
    document.addEventListener("click", $c760ed1227d077e8$var$handleOutsideDialogClick(dialogName));
    if (!(0, $d5d5633d8628c6dd$export$af20da7343c4b20b).isSolved) // remove user input event listeners to prevent interaction
    (0, $b7ff0426b12c667f$export$7da0d8f971993eb)();
}
function $c760ed1227d077e8$var$closeDialog(dialogName) {
    if (dialogName === "settings") {
        // Get corresponding dialog button
        var settingsBtn = document.body.querySelector(".settings-btn");
        // add dialog exit animation
        (0, $35395ebfc9972efa$export$48363b365af47301)($c760ed1227d077e8$var$settingsDialog);
        setTimeout(function() {
            // close dialog after animation duration and blur away from the button
            $c760ed1227d077e8$var$settingsDialog.close();
            settingsBtn.blur();
        }, 450);
    } else if (dialogName === "howToPlay") {
        var howToPlayBtn = document.body.querySelector(".how-to-play-btn");
        // add dialog exit animation
        (0, $35395ebfc9972efa$export$48363b365af47301)($c760ed1227d077e8$var$howToPlayDialog);
        // close dialog after animation duration
        setTimeout(function() {
            $c760ed1227d077e8$var$howToPlayDialog.close();
            howToPlayBtn.blur();
        }, 450);
    }
    // remove both dialog related event listeners
    document.removeEventListener("keydown", $c760ed1227d077e8$var$EscKeyDialogEvent);
    document.removeEventListener("click", $c760ed1227d077e8$var$outsideDialogAreaEvent);
    if (!(0, $d5d5633d8628c6dd$export$af20da7343c4b20b).isSolved) // add user input event listeners to regain interactivity
    (0, $b7ff0426b12c667f$export$9bcec1d37b9fc29c)();
}
/*
  * this function handles the press of an ESC key if a dialog is opened
*/ // reference
var $c760ed1227d077e8$var$EscKeyDialogEvent;
function $c760ed1227d077e8$var$handleEscKeyClick(dialogName) {
    $c760ed1227d077e8$var$EscKeyDialogEvent = function(ev) {
        if (ev.key === "Escape") {
            // prevent default behavior for ESC key with modal dialogs
            ev.preventDefault();
            // close the dialog
            $c760ed1227d077e8$var$closeDialog(dialogName);
        }
    };
    return $c760ed1227d077e8$var$EscKeyDialogEvent;
}
/*
  * this function handles mouse clicks outside of the dialog area
*/ // reference
var $c760ed1227d077e8$var$outsideDialogAreaEvent;
function $c760ed1227d077e8$var$handleOutsideDialogClick(dialogName) {
    $c760ed1227d077e8$var$outsideDialogAreaEvent = function(ev) {
        if (ev.target instanceof HTMLDialogElement) $c760ed1227d077e8$var$closeDialog(dialogName);
    };
    return $c760ed1227d077e8$var$outsideDialogAreaEvent;
}
//**********************************
//* Settings dialog Functions
//**********************************/
function $c760ed1227d077e8$export$afc52e0074cd9f19() {
    var settingsBtn = document.querySelector(".settings-btn");
    var settingsCloseBtn = document.querySelector(".settings-close");
    settingsBtn.addEventListener("click", $c760ed1227d077e8$var$openSettingsEvent);
    settingsCloseBtn.addEventListener("click", $c760ed1227d077e8$var$closeSettingsEvent);
}
function $c760ed1227d077e8$var$openSettingsEvent() {
    $c760ed1227d077e8$var$openDialog("settings");
}
function $c760ed1227d077e8$var$closeSettingsEvent() {
    $c760ed1227d077e8$var$closeDialog("settings");
}
//**********************************
//* Dark mode Functions
//**********************************/
//*********************
//* Main Functions
//*********************/
//* initial check function to know if a switch to dark theme is needed based on user preference
function $c760ed1227d077e8$export$c4af5bec915d38ad() {
    // get current user preference
    var userPreference = $c760ed1227d077e8$var$detectPreferredColorScheme();
    if (userPreference === "dark") // switch to dark theme
    $c760ed1227d077e8$var$handleThemeChange();
}
//* main function for the dark mode button
function $c760ed1227d077e8$export$5dd67a880f168c58() {
    // add theme button event listener
    $c760ed1227d077e8$var$checkbox.addEventListener("click", $c760ed1227d077e8$var$handleThemeChange);
}
//*********************
//* Helper Functions
//*********************/
//* main event handler for the dark mode button
function $c760ed1227d077e8$var$handleThemeChange() {
    // get current theme
    var currentTheme = $c760ed1227d077e8$var$checkbox.getAttribute("data-theme");
    // get single elements with single class corresponding to them
    var singleElements = $c760ed1227d077e8$var$getSingleElements($c760ed1227d077e8$var$singleElementsClasses);
    // get multiple elements with single class corresponding to them
    var multipleElements = $c760ed1227d077e8$var$getMultipleElements($c760ed1227d077e8$var$multipleElementsClasses);
    // if current theme is light or on first theme change
    if (currentTheme === "light") // add dark mode classes
    $c760ed1227d077e8$var$addDarkTheme(singleElements, multipleElements);
    else // remove dark mode classes
    $c760ed1227d077e8$var$removeDarkTheme(singleElements, multipleElements);
}
//* detect user preferred color scheme
function $c760ed1227d077e8$var$detectPreferredColorScheme() {
    // on first session
    if (localStorage.getItem("themePreference") === null) {
        // get user preferred color scheme
        var prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        // save user preference in local storage
        prefersDark ? localStorage.setItem("themePreference", "dark") : localStorage.setItem("themePreference", "light");
        // if dark is preferable, click the checkbox to apply visual changes to button
        if (prefersDark && $c760ed1227d077e8$var$checkbox.getAttribute("data-theme") === "light") $c760ed1227d077e8$var$checkbox.click();
        // return user preference
        return localStorage.getItem("themePreference");
    } else return localStorage.getItem("themePreference");
}
//* Dark mode applying function
function $c760ed1227d077e8$var$addDarkTheme(singleElements, multipleElements) {
    // change user preference in local storage to dark
    localStorage.setItem("themePreference", "dark");
    // change checkbox current theme attribute to dark
    $c760ed1227d077e8$var$checkbox.setAttribute("data-theme", "dark");
    // check the checkbox to apply visual changes => (handled with css)
    $c760ed1227d077e8$var$checkbox.checked = true;
    // handle SVG changes
    $c760ed1227d077e8$var$svgChanger($c760ed1227d077e8$var$lightThemeSVGs, $c760ed1227d077e8$var$darkThemeSVGs, "dark");
    // add theme to general elements
    var body = document.body;
    body.classList.add("body--dark");
    var header = document.body.querySelector("header");
    header.classList.add("header--dark");
    var dialogs = document.body.querySelectorAll("dialog");
    dialogs.forEach(function(dialog) {
        dialog.classList.add("dialog--dark");
    });
    // add dark mode to single elements using their class
    if (singleElements.length > 0) $c760ed1227d077e8$var$handleSingleElements(singleElements, "add");
    // add dark mode classes to each group of elements with a single class
    if (multipleElements.length > 0) $c760ed1227d077e8$var$handleMultipleElements(multipleElements, "add");
}
//* Dark mode removing function
function $c760ed1227d077e8$var$removeDarkTheme(singleElements, multipleElements) {
    // change user preference in local storage to light
    localStorage.setItem("themePreference", "light");
    // change checkbox current theme attribute to light
    $c760ed1227d077e8$var$checkbox.setAttribute("data-theme", "light");
    // handle SVG changes
    $c760ed1227d077e8$var$svgChanger($c760ed1227d077e8$var$lightThemeSVGs, $c760ed1227d077e8$var$darkThemeSVGs, "light");
    // remove theme from general elements
    var body = document.body;
    body.classList.remove("body--dark");
    var header = document.body.querySelector("header");
    header.classList.remove("header--dark");
    var dialogs = document.body.querySelectorAll("dialog");
    dialogs.forEach(function(dialog) {
        dialog.classList.remove("dialog--dark");
    });
    // remove dark mode from single elements using their class
    if (singleElements.length > 0) $c760ed1227d077e8$var$handleSingleElements(singleElements, "remove");
    // remove dark mode classes for each group of elements with a single class
    if (multipleElements.length > 0) $c760ed1227d077e8$var$handleMultipleElements(multipleElements, "remove");
}
/*
  * Function that takes an array of Elements from the DOM, and based on the method
  * either adds or removes dark mode classes based on the corresponding singleElementsClasses
*/ function $c760ed1227d077e8$var$handleSingleElements(elements, method) {
    elements.forEach(function(elem) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = elem.classList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elemClass = _step.value;
                if ($c760ed1227d077e8$var$singleElementsClasses.includes(elemClass)) {
                    if (method === "add") elem.classList.add("".concat(elemClass, "--dark"));
                    else if (method === "remove") elem.classList.remove("".concat(elemClass, "--dark"));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/*
  * Function that takes an array of nodeLists from the DOM, and based on the method
  * either adds or removes dark mode classes based on the corresponding multipleElementsClasses
*/ function $c760ed1227d077e8$var$handleMultipleElements(elements, method) {
    elements.forEach(function(group) {
        // check it's not an empty nodeList
        if (group.length > 0) group.forEach(function(child) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                /* 
          * for each element classList check for which classes he have from
          * the multipleElementsClasses array
        */ for(var _iterator = child.classList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elemClass = _step.value;
                    // elements classes that needs one hyphen to apply dark mode classes
                    var singleHyphenArr = $c760ed1227d077e8$var$multipleElementsClasses[0];
                    // elements that needs two hyphens
                    var doubleHyphenArr = $c760ed1227d077e8$var$multipleElementsClasses[1];
                    if (singleHyphenArr.includes(elemClass)) {
                        if (method === "add") child.classList.add("".concat(elemClass, "-dark"));
                        else if (method === "remove") child.classList.remove("".concat(elemClass, "-dark"));
                    } else if (doubleHyphenArr.includes(elemClass)) {
                        if (method === "add") child.classList.add("".concat(elemClass, "--dark"));
                        else if (method === "remove") child.classList.remove("".concat(elemClass, "--dark"));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    });
}
/*
  * Function that takes as argument an array of class names which are associated with
  * only one element, and returns an array of elements from the DOM
*/ function $c760ed1227d077e8$var$getSingleElements(singleElementsClasses) {
    // initial array to store single elements
    var singleElements = [];
    // get elements
    singleElementsClasses.forEach(function(elem) {
        var element = $c760ed1227d077e8$var$getElement(elem);
        singleElements.push(element);
    });
    return singleElements;
}
/*
  * Function that takes as argument an array of class names which are associated with
  * multiple elements, and returns an array of nodeLists of elements from the DOM
*/ function $c760ed1227d077e8$var$getMultipleElements(multipleElementsClasses) {
    // initial array to store multiple elements
    var multipleElements = [];
    multipleElementsClasses.forEach(function(hyphenArr) {
        hyphenArr.forEach(function(group) {
            var elements = $c760ed1227d077e8$var$getElements(group);
            multipleElements.push(elements);
        });
    });
    return multipleElements;
}
// Function that takes a class name and returns one element from the DOM
function $c760ed1227d077e8$var$getElement(elementName) {
    return document.body.querySelector(".".concat(elementName));
}
//* Function that takes a class name and returns all associated elements from the DOM
function $c760ed1227d077e8$var$getElements(elementsName) {
    return document.body.querySelectorAll(".".concat(elementsName));
}
//* Function that handles SVG elements and changes them based on the current theme
function $c760ed1227d077e8$var$svgChanger(lightSVGs, darkSVGs, theme) {
    if (theme === "light") {
        lightSVGs.forEach(function(svg) {
            svg.removeAttribute("hidden");
        });
        darkSVGs.forEach(function(svg) {
            svg.setAttribute("hidden", "true");
        });
    } else if (theme === "dark") {
        darkSVGs.forEach(function(svg) {
            svg.removeAttribute("hidden");
        });
        lightSVGs.forEach(function(svg) {
            svg.setAttribute("hidden", "true");
        });
    }
}
//**********************************
//* how to play dialog Functions
//**********************************/
function $c760ed1227d077e8$export$d646718b184468fc() {
    var howToPlayBtn = document.body.querySelector(".how-to-play-btn");
    var howToPlayCloseBtn = document.body.querySelector(".how-to-play-close");
    howToPlayBtn.addEventListener("click", $c760ed1227d077e8$export$37507772aae22b47);
    howToPlayCloseBtn.addEventListener("click", $c760ed1227d077e8$var$closeHowToPlayDialog);
}
function $c760ed1227d077e8$export$37507772aae22b47() {
    // open how-to-play dialog
    $c760ed1227d077e8$var$openDialog("howToPlay");
    // get fake word row in the dialog
    var fakeWordRow = document.querySelector(".fake-game-row");
    var fakeWordCells = fakeWordRow.children;
    // animate the fake row when in viewport
    $c760ed1227d077e8$var$fakeRowObserver(fakeWordRow, fakeWordCells);
}
function $c760ed1227d077e8$var$closeHowToPlayDialog() {
    $c760ed1227d077e8$var$closeDialog("howToPlay");
}
/*
  * Function to observe if the fake word row in settings dialog is in viewport 
*/ function $c760ed1227d077e8$var$fakeRowObserver(fakeWordRow, fakeWordCells) {
    //* to avoid repeating animations if scrolled more than once
    var observationsLeft = 1;
    // the callback for observer
    function fakeRowCallback(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && observationsLeft > 0) {
                observationsLeft--;
                (0, $35395ebfc9972efa$export$8be79abfbbb1b7ab)(fakeWordCells);
            }
        });
    }
    // observer options
    var intersectionOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 1
    };
    // create a new observer
    var observer = new IntersectionObserver(fakeRowCallback, intersectionOptions);
    // observe the fake row
    observer.observe(fakeWordRow);
}




//********************* */
//* Global Variables
//********************* */
// keyboardElement And keyboard buttons
var $b7ff0426b12c667f$var$keyboardContainer = document.querySelector(".keyboard");
var $b7ff0426b12c667f$var$keyboardBtns = document.querySelectorAll(".keyboard__letter");
// row cells first change state
var $b7ff0426b12c667f$var$cellsChanged = false;
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Double Functions which switches application's functionality on and off
*/ function $b7ff0426b12c667f$export$9bcec1d37b9fc29c() {
    $b7ff0426b12c667f$var$handleKeyDown();
    $b7ff0426b12c667f$var$handleKeyupEvent();
    $b7ff0426b12c667f$var$handleKeyboardClicks();
}
function $b7ff0426b12c667f$export$7da0d8f971993eb() {
    document.body.removeEventListener("keydown", $b7ff0426b12c667f$var$onKeyDownEvent);
    document.body.removeEventListener("keyup", $b7ff0426b12c667f$var$onKeyUp);
    $b7ff0426b12c667f$var$keyboardContainer.removeEventListener("click", $b7ff0426b12c667f$var$keyboardClickEvent);
}
/*
  * function that handles all buttons events in the app
*/ function $b7ff0426b12c667f$export$cfb94089535b8ca7() {
    (0, $c760ed1227d077e8$export$afc52e0074cd9f19)();
    (0, $c760ed1227d077e8$export$5dd67a880f168c58)();
    (0, $c760ed1227d077e8$export$d646718b184468fc)();
}
function $b7ff0426b12c667f$var$handleKeyDown() {
    return $b7ff0426b12c667f$var$_handleKeyDown.apply(this, arguments);
}
function $b7ff0426b12c667f$var$_handleKeyDown() {
    $b7ff0426b12c667f$var$_handleKeyDown = //****************************************************** */
    //* Helper Functions
    //****************************************************** */
    (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var wordOfTheDay;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $b7ce30cf16a265d9$export$a5bfddfac516cc04)()
                    ];
                case 1:
                    wordOfTheDay = _state.sent();
                    document.body.addEventListener("keydown", $b7ff0426b12c667f$var$onKeyDown(wordOfTheDay));
                    return [
                        2
                    ];
            }
        });
    });
    return $b7ff0426b12c667f$var$_handleKeyDown.apply(this, arguments);
}
// reference to keyDown event function
var $b7ff0426b12c667f$var$onKeyDownEvent;
function $b7ff0426b12c667f$var$onKeyDown(wordOfTheDay) {
    $b7ff0426b12c667f$var$onKeyDownEvent = function onKeyDownEvent(ev) {
        if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow < 6) {
            // current active gameBoard row
            var rowCells = document.querySelectorAll(".game-board__row")[(0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow].children;
            // pressed key value
            var key = ev.key;
            // check if gameBoard values has been changed
            $b7ff0426b12c667f$var$cellsChanged = (0, $5a4e68405bab07b3$export$412508d679148d5c)(rowCells, key);
            if ($b7ff0426b12c667f$var$cellsChanged) {
                /*
          * handle cells adding animation only here
            ** backspace animation is handled in the handleInput function
            ** enter animation is handled in the enter block (completeValidationCheck)
        */ if (key !== "Backspace" && key !== "Enter") (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells, key);
                // handle enter key animation in the enter validation block
                if (key !== "Enter") (0, $35395ebfc9972efa$export$5c4515537cbee0e0)($b7ff0426b12c667f$var$keyboardBtns, key);
                // if validation
                if (key === "Enter") {
                    // check the current focused element
                    var currentFocusedElement = document.activeElement;
                    // apply only if the focused element is the body or the Enter button
                    if (currentFocusedElement instanceof HTMLBodyElement || currentFocusedElement.classList.contains(".enter-button")) {
                        // handle enter keyboard animation
                        (0, $35395ebfc9972efa$export$5c4515537cbee0e0)($b7ff0426b12c667f$var$keyboardBtns, key);
                        // do a complete validation check
                        (0, $8652910d8928cb3c$export$e41ca8f156de93e6)(rowCells, $b7ff0426b12c667f$var$keyboardBtns, wordOfTheDay);
                    }
                }
            }
        }
    };
    return $b7ff0426b12c667f$var$onKeyDownEvent;
}
function $b7ff0426b12c667f$var$handleKeyupEvent() {
    // releasing user keyboard buttons event
    document.body.addEventListener("keyup", $b7ff0426b12c667f$var$onKeyUp);
}
function $b7ff0426b12c667f$var$onKeyUp(ev) {
    var key = ev.key;
    (0, $35395ebfc9972efa$export$82f1d4313688e804)($b7ff0426b12c667f$var$keyboardBtns, key);
}
function $b7ff0426b12c667f$var$handleKeyboardClicks() {
    return $b7ff0426b12c667f$var$_handleKeyboardClicks.apply(this, arguments);
}
function $b7ff0426b12c667f$var$_handleKeyboardClicks() {
    $b7ff0426b12c667f$var$_handleKeyboardClicks = (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var wordOfTheDay;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $b7ce30cf16a265d9$export$a5bfddfac516cc04)()
                    ];
                case 1:
                    wordOfTheDay = _state.sent();
                    $b7ff0426b12c667f$var$keyboardContainer.addEventListener("click", $b7ff0426b12c667f$var$onKeyboardClick(wordOfTheDay));
                    return [
                        2
                    ];
            }
        });
    });
    return $b7ff0426b12c667f$var$_handleKeyboardClicks.apply(this, arguments);
}
// reference to the event function (for removal purposes)
var $b7ff0426b12c667f$var$keyboardClickEvent;
function $b7ff0426b12c667f$var$onKeyboardClick(wordOfTheDay) {
    // store function
    $b7ff0426b12c667f$var$keyboardClickEvent = function keyboardClickEvent(ev) {
        if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow < 6) {
            // current active gameBoard row
            var rowCells = document.querySelector(".game-board__row[data-state='TBD']").children;
            // current clicked button
            var clickedButton = ev.target;
            // if not a button
            if (!(clickedButton instanceof HTMLButtonElement || clickedButton instanceof HTMLImageElement)) return;
            if (clickedButton instanceof HTMLImageElement || clickedButton.classList.contains("backspace-button")) $b7ff0426b12c667f$var$cellsChanged = (0, $5a4e68405bab07b3$export$412508d679148d5c)(rowCells, "Backspace");
            else if (clickedButton.classList.contains("enter-button")) {
                $b7ff0426b12c667f$var$cellsChanged = (0, $5a4e68405bab07b3$export$412508d679148d5c)(rowCells, "Enter");
                // do a complete validation check
                (0, $8652910d8928cb3c$export$e41ca8f156de93e6)(rowCells, $b7ff0426b12c667f$var$keyboardBtns, wordOfTheDay);
            } else {
                $b7ff0426b12c667f$var$cellsChanged = (0, $5a4e68405bab07b3$export$412508d679148d5c)(rowCells, clickedButton.innerHTML);
                if ($b7ff0426b12c667f$var$cellsChanged) (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells, clickedButton.innerHTML);
            }
            // deFocus from the clicked button
            clickedButton.blur();
        }
    };
    // return to the currying function
    return $b7ff0426b12c667f$var$keyboardClickEvent;
}




//********************* */
//* Global Variables
//********************* */
// track on screen feedback
var $8652910d8928cb3c$var$feedbackOnScreen = false;
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Function to display feedback messages on screen
  * message => the message displayed in the feedback element
  * stayOnScreen => boolean indicating whether the feedback will stay on screen or not
  * timeOnScreen => only needed if stayOnScreen is false, to represent the time on screen in seconds before removal
*/ function $8652910d8928cb3c$export$6ec214f034b61612(message, stayOnScreen, timeOnScreen) {
    var feedbackElement = document.querySelector(".feedback-message");
    feedbackElement.innerHTML = "".concat(message);
    if (!$8652910d8928cb3c$var$feedbackOnScreen) $8652910d8928cb3c$var$displayFeedback(feedbackElement, stayOnScreen, timeOnScreen);
}
function $8652910d8928cb3c$export$e41ca8f156de93e6(rowCells, keyboardBtns, wordOfTheDay) {
    return $8652910d8928cb3c$var$_completeValidationCheck.apply(this, arguments);
}
function $8652910d8928cb3c$var$_completeValidationCheck() {
    $8652910d8928cb3c$var$_completeValidationCheck = /*
  * the main Function to handle the full process of validating
    ** Checks if row is complete
    ** assembles the word if complete, otherwise does the corresponding animation
    ** handleValidation => returns false => if word is invalid or on server error
    ** => returns an array of boolean and string values indicating similarity between the two words
    ** handle related animations based on handleValidation return value
    ** in case of a successful validation check, Save game state and check if it's "game over"
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function(rowCells, keyboardBtns, wordOfTheDay) {
        var rowComplete, userInput, similarLetters;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    rowComplete = $8652910d8928cb3c$var$rowCheck(rowCells);
                    if (!rowComplete) return [
                        3,
                        2
                    ];
                    // show loading indicator
                    (0, $35395ebfc9972efa$export$64858b67578a10bb)();
                    userInput = $8652910d8928cb3c$var$assembleWord(rowCells);
                    return [
                        4,
                        $8652910d8928cb3c$var$handleValidation(wordOfTheDay, userInput, rowCells, keyboardBtns)
                    ];
                case 1:
                    similarLetters = _state.sent();
                    // hide loading indicator
                    (0, $35395ebfc9972efa$export$7d026bf51c574e0d)();
                    if (similarLetters === false) // do invalid word animation
                    (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells, "enter");
                    else {
                        // Animate changes to row cells and keyboard buttons based on their similarity
                        (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells, "enter", similarLetters, keyboardBtns);
                        // Mark row as completed
                        document.querySelectorAll(".game-board__row")[(0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow].dataset.state = "DONE";
                        // save current game state after animations durations has completed
                        setTimeout(function() {
                            (0, $d5d5633d8628c6dd$export$384cd953322e3851)(rowCells);
                        }, 1200);
                    }
                    // check if game ended
                    if (similarLetters !== false) $8652910d8928cb3c$var$endGameCheck();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $8652910d8928cb3c$var$_completeValidationCheck.apply(this, arguments);
}
//****************************************************** */
//* Helper Functions
//****************************************************** */
/*
  * function that displays feedback on the screen
  * elem => takes the feedback element as a first argument
  * stayOnScreen => boolean indicating whether the feedback will stay on screen or not
  * timeInSeconds => elapsed time for each feedback message
*/ function $8652910d8928cb3c$var$displayFeedback(elem, stayOnScreen, timeInSeconds) {
    // add entry animation
    elem.classList.add("fade-in-feedback");
    $8652910d8928cb3c$var$feedbackOnScreen = true;
    if (!stayOnScreen) {
        // remove entry animation, apply and remove exit animation
        setTimeout(function() {
            elem.classList.remove("fade-in-feedback");
            elem.classList.add("fade-out-feedback");
        }, timeInSeconds * 1000);
        setTimeout(function() {
            elem.classList.remove("fade-out-feedback");
            $8652910d8928cb3c$var$feedbackOnScreen = false;
        }, timeInSeconds * 1000 + 500);
    }
}
//* Function that checks if row cells are complete
function $8652910d8928cb3c$var$rowCheck(rowCells) {
    var rowComplete = false;
    for(var i = 0; i < rowCells.length; i++)if (rowCells[i].innerText === "") {
        // Give feedback to the user
        $8652910d8928cb3c$export$6ec214f034b61612("Not Enough Letters", false, 1);
        // do rejection animation
        (0, $35395ebfc9972efa$export$2b30b4c5c46f02b8)(rowCells, "enter");
        rowComplete = false;
        break;
    } else rowComplete = true;
    return rowComplete;
}
//* Connect row letters into a word
function $8652910d8928cb3c$var$assembleWord(rowCells) {
    var string = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rowCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            string += cell.textContent;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return string;
}
function $8652910d8928cb3c$var$handleValidation(wordOfTheDay, userInput) {
    return $8652910d8928cb3c$var$_handleValidation.apply(this, arguments);
}
function $8652910d8928cb3c$var$_handleValidation() {
    $8652910d8928cb3c$var$_handleValidation = /*
  * handleValidation returns:
  * false => in case of invalid user input
  * Array that represents similarity between userInput and word of the day
  * based on index of characters => in case of a valid user input
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function(wordOfTheDay, userInput) {
        var similarLetters, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, letter, winFeedbackTime;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // if there is no word of the day (i.e Fetch Failed)
                    if (wordOfTheDay === undefined) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        $8652910d8928cb3c$var$compareWords(wordOfTheDay, userInput)
                    ];
                case 1:
                    similarLetters = _state.sent();
                    // if user input is invalid
                    if (similarLetters === false) return [
                        2,
                        false
                    ];
                    else {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // check if word is solved
                            for(_iterator = similarLetters[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                letter = _step.value;
                                if (letter === true) (0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).isSolved = true;
                                else {
                                    (0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).isSolved = false;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).isSolved) {
                            winFeedbackTime = 2.5;
                            switch((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow){
                                case 0:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Exceptional", false, winFeedbackTime);
                                    break;
                                case 1:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Incredible", false, winFeedbackTime);
                                    break;
                                case 2:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Impressive", false, winFeedbackTime);
                                    break;
                                case 3:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Great", false, winFeedbackTime);
                                    break;
                                case 4:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Nice", false, winFeedbackTime);
                                    break;
                                default:
                                    $8652910d8928cb3c$export$6ec214f034b61612("Phew", false, winFeedbackTime);
                            }
                        } else if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow === 5) $8652910d8928cb3c$export$6ec214f034b61612("Correct word: ".concat(wordOfTheDay.toUpperCase()), true);
                        // return similarLetters
                        return [
                            2,
                            similarLetters
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $8652910d8928cb3c$var$_handleValidation.apply(this, arguments);
}
function $8652910d8928cb3c$var$compareWords(wordOfTheDay, userInput) {
    return $8652910d8928cb3c$var$_compareWords.apply(this, arguments);
}
function $8652910d8928cb3c$var$_compareWords() {
    $8652910d8928cb3c$var$_compareWords = /*
  * This function compares both words (word of the day , user input) for similarity
  * returns false and displays feedback => if user input is an invalid word
  * returns false only => 
    ** if the isWord function returns undefined 
    ** if the words are not equal in length or the word of the day has any invalid characters
  
  * returns a mixed array of booleans and strings => in case of a valid check
  * with the three values:
    ** true => for characters available in both words at the same position
    ** "close" => for characters available in both words at different positions
    ** false => for characters missing from one word compared to the other
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function(wordOfTheDay, userInput) {
        var validWord, similarLetters, i, foundIndices;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $8652910d8928cb3c$var$isWord(userInput)
                    ];
                case 1:
                    validWord = _state.sent();
                    // if invalid word
                    if (validWord === false) {
                        $8652910d8928cb3c$export$6ec214f034b61612("Not In Word List", false, 1.5);
                        return [
                            2,
                            false
                        ];
                    } else if (validWord === undefined) return [
                        2,
                        false
                    ];
                    // check words lengths
                    if (/\d/.test(wordOfTheDay) || wordOfTheDay.length !== userInput.length) {
                        $8652910d8928cb3c$export$6ec214f034b61612("Server Error, Enjoy a cookie while we work on it \uD83D\uDE19", true);
                        return [
                            2,
                            false
                        ];
                    }
                    similarLetters = Array.from(userInput, function() {
                        return false;
                    });
                    // unify input
                    wordOfTheDay = wordOfTheDay.toLowerCase();
                    userInput = userInput.toLowerCase();
                    // check for similarity between letters
                    for(i = 0; i < wordOfTheDay.length; i++){
                        foundIndices = $8652910d8928cb3c$var$findLetterIndices(userInput, wordOfTheDay[i]);
                        // if word of the day letter is found only once in user input
                        if (foundIndices.length === 1) $8652910d8928cb3c$var$handleSingleOccurrence(foundIndices[0], i, similarLetters);
                        else $8652910d8928cb3c$var$handleMultipleOccurrences(foundIndices, i, similarLetters);
                    }
                    return [
                        2,
                        similarLetters
                    ];
            }
        });
    });
    return $8652910d8928cb3c$var$_compareWords.apply(this, arguments);
}
/*
  * This function returns an array of all found indices for the second argument (letter)
  * inside of the first argument (word)
*/ function $8652910d8928cb3c$var$findLetterIndices(userInputWord, wordOfTheDayLetter) {
    // initial array to track all found indices
    var foundIndices = [];
    // check for first occurrence of word of the day letter in the user input
    var currentFound = userInputWord.indexOf(wordOfTheDayLetter);
    // check for any subsequent occurrences
    while(currentFound !== -1){
        // push the first found occurrence
        foundIndices.push(currentFound);
        // look for further indices following the last occurrence
        currentFound = userInputWord.indexOf(wordOfTheDayLetter, currentFound + 1);
    }
    return foundIndices;
}
//* This function handles single letter occurrence in wordOfTheDay
function $8652910d8928cb3c$var$handleSingleOccurrence(foundIndex, currentIndex, similarLetters) {
    if (foundIndex === currentIndex) similarLetters[foundIndex] = true;
    else if (similarLetters[foundIndex] === false) similarLetters[foundIndex] = "close";
}
//* This function handles multiple letter occurrences in wordOfTheDay
function $8652910d8928cb3c$var$handleMultipleOccurrences(foundIndices, todayWordLetterIndex, similarLetters) {
    /*
    * initial differences between userInput Indices and current word of the day letter
      ** for example: if found index is 1 and word of the day letter index is 4 => difference is 3
      ** map key => found index
      ** map key value => indices difference
  */ var indicesDifferences = new Map();
    // get Indices differences
    foundIndices.forEach(function(foundIndex) {
        var foundIndexDifference = Math.abs(foundIndex - todayWordLetterIndex);
        indicesDifferences.set("".concat(foundIndex), foundIndexDifference);
    });
    // find closest found index to word of the day letter
    var closestIndex = $8652910d8928cb3c$var$findClosestIndex(indicesDifferences);
    // remove entry (to avoid including in future searches)
    indicesDifferences.delete(closestIndex);
    if (Number(closestIndex) === todayWordLetterIndex) similarLetters[closestIndex] = true;
    else // if hasn't been processed yet
    if (similarLetters[closestIndex] === false) // mark as close
    similarLetters[closestIndex] = "close";
    else // look for the next closest index that hasn't been processed
    $8652910d8928cb3c$var$handleRemainingDifferences(indicesDifferences, similarLetters);
}
//* This function return the first index with the lowest difference
function $8652910d8928cb3c$var$findClosestIndex(differencesMap) {
    // Get closest Index based on smallest difference
    var minEntry = (0, $2c5e0c4ca64c569e$export$1b5e630bc3aea29f)(differencesMap.entries()).reduce(function(arr, param) {
        var _param = (0, $6bdb1ac2f8376318$export$fdf2a89c76341bbf)(param, 2), index = _param[0], diff = _param[1];
        return diff < arr[1] ? [
            index,
            diff
        ] : arr;
    }, [
        null,
        Infinity
    ]);
    return minEntry[0];
}
/*
  * This function checks for an unprocessed subsequent letter index
  * either handling it (if found) or exhausting and nulling the differences Map
*/ function $8652910d8928cb3c$var$handleRemainingDifferences(differencesMap, similarLetters) {
    while(differencesMap.size > 0){
        // find closest index and delete from future searches
        var closestIndex = $8652910d8928cb3c$var$findClosestIndex(differencesMap);
        differencesMap.delete(closestIndex);
        // if an unprocessed index is found, handle and break out of loop
        if (similarLetters[closestIndex] === false) {
            similarLetters[closestIndex] = "close";
            break;
        }
    }
}
function $8652910d8928cb3c$var$isWord(word) {
    return $8652910d8928cb3c$var$_isWord.apply(this, arguments);
}
function $8652910d8928cb3c$var$_isWord() {
    $8652910d8928cb3c$var$_isWord = /*
  * This function check if the user input is a valid word
    ** returns true => in case of a valid word
    ** returns false => in case of an invalid word
    ** returns undefined => if there is no internet or on API server errors
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function(word) {
        var request, responseObject;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("https://words.dev-apis.com/validate-word", {
                            method: "POST",
                            body: JSON.stringify({
                                "word": "".concat(word)
                            }),
                            headers: {
                                "Content-Type": "application/json",
                                "Connection": "keep-alive"
                            }
                        }).catch(function() {
                            $8652910d8928cb3c$export$6ec214f034b61612("Server Error, please check your internet connection \uD83D\uDE1E", false, 3);
                        })
                    ];
                case 1:
                    request = _state.sent();
                    if (request === undefined) return [
                        2,
                        undefined
                    ];
                    return [
                        4,
                        request.json()
                    ];
                case 2:
                    responseObject = _state.sent();
                    return [
                        2,
                        responseObject.validWord
                    ];
            }
        });
    });
    return $8652910d8928cb3c$var$_isWord.apply(this, arguments);
}
/*
  *  Function to check if the word has been solved
    ** removes functionality => if word has been solved
    ** switches to next row => if current row is not last row
*/ function $8652910d8928cb3c$var$endGameCheck() {
    // update the row
    if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).isSolved) (0, $b7ff0426b12c667f$export$7da0d8f971993eb)();
    else if ((0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow < 6) // increment to next row after animations durations has completed
    setTimeout(function() {
        (0, $d5d5633d8628c6dd$export$7abfd4649f15e11f).currentRow++;
    }, 1200);
}



function $b7ce30cf16a265d9$export$a5bfddfac516cc04() {
    return $b7ce30cf16a265d9$var$_getTodayWord.apply(this, arguments);
}
function $b7ce30cf16a265d9$var$_getTodayWord() {
    $b7ce30cf16a265d9$var$_getTodayWord = //********************* */
    //* Main Functions
    //********************* */
    /*
  * The main function for fetching word of the day
    ** if first session or first fetch of the day => returns the word from the API
    ** otherwise => returns the word from local storage
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var isNewDay;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isNewDay = $b7ce30cf16a265d9$export$c3e675fb255e6adf();
                    if (!(localStorage.getItem("wordOfTheDay") === null || isNewDay)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $b7ce30cf16a265d9$var$initNewWord()
                    ];
                case 1:
                    // initialize a new word in local storage and return it
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        $b7ce30cf16a265d9$var$decodeWord(localStorage.getItem("wordOfTheDay"))
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $b7ce30cf16a265d9$var$_getTodayWord.apply(this, arguments);
}
/*
  * This function compares current day vs day saved in local storage
    ** true => if first user session or a day has passed
    ** false => if still the same day
*/ function $b7ce30cf16a265d9$export$c3e675fb255e6adf() {
    // if first user session
    var firstSession = $b7ce30cf16a265d9$var$isDayNotFound();
    if (firstSession) {
        // set new date key
        $b7ce30cf16a265d9$export$a3ec1d5da0d8ff59();
        // open how to play dialog
        $b7ce30cf16a265d9$var$delayedHowToPlayOpen();
        // return that a day has passed
        return true;
    } else {
        var todayDate = $b7ce30cf16a265d9$var$getTodayDate();
        // compare current day against localStorage saved day
        return todayDate !== localStorage.getItem("currentDay");
    }
}
function $b7ce30cf16a265d9$var$initNewWord() {
    return $b7ce30cf16a265d9$var$_initNewWord.apply(this, arguments);
}
function $b7ce30cf16a265d9$var$_initNewWord() {
    $b7ce30cf16a265d9$var$_initNewWord = //********************* */
    //* Helper Functions
    //********************* */
    //* Function to get a new word from the API
    (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var wordOfTheDay;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $b7ce30cf16a265d9$var$requestWordOfTheDay()
                    ];
                case 1:
                    wordOfTheDay = _state.sent();
                    // encode and store in local storage
                    localStorage.setItem("wordOfTheDay", $b7ce30cf16a265d9$var$encodeWord(wordOfTheDay));
                    return [
                        2,
                        wordOfTheDay
                    ];
            }
        });
    });
    return $b7ce30cf16a265d9$var$_initNewWord.apply(this, arguments);
}
function $b7ce30cf16a265d9$var$requestWordOfTheDay() {
    return $b7ce30cf16a265d9$var$_requestWordOfTheDay.apply(this, arguments);
}
function $b7ce30cf16a265d9$var$_requestWordOfTheDay() {
    $b7ce30cf16a265d9$var$_requestWordOfTheDay = //* Function to handle Promise resolution or rejection when fetching a new word
    (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var promise;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            promise = fetch("https://words.dev-apis.com/word-of-the-day");
            return [
                2,
                promise.then(function(response) {
                    return response.json();
                }).then(function(responseObject) {
                    return responseObject.word;
                }).catch(function() {
                    (0, $8652910d8928cb3c$export$6ec214f034b61612)("Server error \uD83D\uDE10", false);
                })
            ];
        });
    });
    return $b7ce30cf16a265d9$var$_requestWordOfTheDay.apply(this, arguments);
}
//* get current day as a string "day/month/year" relative to GMT+0000 (UTC) => reset time for word of the day
function $b7ce30cf16a265d9$var$getTodayDate() {
    var currentDate = new Date();
    var currentDay = "".concat(currentDate.getUTCDate(), "/").concat(currentDate.getUTCMonth() + 1, "/").concat(currentDate.getUTCFullYear());
    return currentDay;
}
//* Function to set a new date
function $b7ce30cf16a265d9$export$a3ec1d5da0d8ff59() {
    localStorage.setItem("currentDay", $b7ce30cf16a265d9$var$getTodayDate());
}
//* Function to remove the current date from the local storage
function $b7ce30cf16a265d9$export$5f9ade464756e316() {
    localStorage.removeItem("currentDay");
}
/*
  * Function to check if a day key does not exist in localStorage
  * if not found => return true
  * otherwise => return false
*/ function $b7ce30cf16a265d9$var$isDayNotFound() {
    if (localStorage.getItem("currentDay") === null) return true;
    else return false;
}
function $b7ce30cf16a265d9$var$delayedHowToPlayOpen() {
    return $b7ce30cf16a265d9$var$_delayedHowToPlayOpen.apply(this, arguments);
}
function $b7ce30cf16a265d9$var$_delayedHowToPlayOpen() {
    $b7ce30cf16a265d9$var$_delayedHowToPlayOpen = /*
  * This is a function that delays the opening of how to play dialog
  * based on network speed
*/ (0, $6b1037497eeac2d9$export$7c398597f8905a1)(function() {
        var startTime, endTime, timeTaken, jsExecutionTime, additionalSafetyDelay;
        return (0, $626eabffe98b4288$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    startTime = performance.now();
                    // get today word and save it in local storage
                    return [
                        4,
                        $b7ce30cf16a265d9$export$a5bfddfac516cc04()
                    ];
                case 1:
                    _state.sent();
                    endTime = performance.now();
                    timeTaken = endTime - startTime;
                    jsExecutionTime = timeTaken * 2;
                    additionalSafetyDelay = 500;
                    //* delay dialog opening based on network speed
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, jsExecutionTime + additionalSafetyDelay);
                        })
                    ];
                case 2:
                    _state.sent();
                    (0, $c760ed1227d077e8$export$37507772aae22b47)();
                    return [
                        2
                    ];
            }
        });
    });
    return $b7ce30cf16a265d9$var$_delayedHowToPlayOpen.apply(this, arguments);
}
//* Function to scramble word of the day before storing it in the local storage
function $b7ce30cf16a265d9$var$encodeWord(word) {
    // fake array to add additional characters from to the encoded string
    var fakeHashArr = [
        "!",
        "$",
        "7",
        "&",
        "?",
        "p",
        "q",
        "r",
        "/",
        "<",
        "g",
        ".",
        "5",
        "i",
        " ",
        "9",
        "4",
        "-",
        ")",
        "D",
        "T",
        "R",
        "{",
        "}",
        "U",
        "Z",
        "t",
        "K",
        "P",
        "~",
        ";",
        "|",
        ":",
        "z",
        "V",
        "W",
        "X",
        "+",
        "=",
        "G",
        "H",
        "I",
        "@",
        "#",
        "%",
        "3",
        ">",
        "^",
        "c",
        "d"
    ];
    var hashArrLen = fakeHashArr.length;
    // initial value for number of letters in encoded word to each letter from original
    var addedCharsForLetter = 26;
    // the index at which resides the real letter
    var OriginalLetterIndex = 11;
    var encodedWord = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // for each letter
        for(var _iterator = word[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var letter = _step.value;
            // add the additional characters
            for(var i = 0; i < addedCharsForLetter; i++)if (i === OriginalLetterIndex) encodedWord += String.fromCharCode(letter.charCodeAt(0) - 64);
            else encodedWord += fakeHashArr[parseInt(Math.random() * 100) % hashArrLen];
            // arbitrarily increment added chars for next letters
            addedCharsForLetter += 17;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return encodedWord;
}
//* Function to unscramble word of the day before retrieving it from the local storage
function $b7ce30cf16a265d9$var$decodeWord(encodedWord) {
    // initial variables
    var addedCharsForLetter = 26;
    var OriginalLetterIndex = 11;
    var decodedWord = "";
    // array to store each chunk in encodedWord holding a letter
    var letters = [];
    // split encoded word until zero letters in length
    while(encodedWord !== ""){
        letters.push(encodedWord.substring(0, addedCharsForLetter));
        encodedWord = encodedWord.slice(addedCharsForLetter);
        addedCharsForLetter += 17;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add only from the encoding key index
        for(var _iterator = letters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var letter = _step.value;
            decodedWord += String.fromCharCode(letter[OriginalLetterIndex].charCodeAt(0) + 64);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return decodedWord;
}





function $01108cba6912beb7$var$main() {
    // check if it's a new day
    var isNewDay = (0, $b7ce30cf16a265d9$export$c3e675fb255e6adf)();
    // if there is a saved game state and a day hasn't passed yet
    if ((0, $d5d5633d8628c6dd$export$af20da7343c4b20b).currentRow !== -1 && !isNewDay) (0, $d5d5633d8628c6dd$export$70a369479cdf5432)((0, $d5d5633d8628c6dd$export$af20da7343c4b20b));
    // do an initial dark mode check
    (0, $c760ed1227d077e8$export$c4af5bec915d38ad)();
    // add input functionality if word hasn't been solved yet for the current day
    if (!(0, $d5d5633d8628c6dd$export$af20da7343c4b20b).isSolved) (0, $b7ff0426b12c667f$export$9bcec1d37b9fc29c)();
    // add buttons event handlers
    (0, $b7ff0426b12c667f$export$cfb94089535b8ca7)();
    // update day if it's a new day
    if (isNewDay) {
        // remove previous date from local storage
        (0, $b7ce30cf16a265d9$export$5f9ade464756e316)();
        // add the new one
        (0, $b7ce30cf16a265d9$export$a3ec1d5da0d8ff59)();
    }
}
$01108cba6912beb7$var$main();

})();
//# sourceMappingURL=index.dc4bffe8.js.map
